export var TimeBreakType;
(function (TimeBreakType) {
    TimeBreakType["LUNCH"] = "lunch";
    TimeBreakType["PAUSE"] = "pause";
    TimeBreakType["OTHER"] = "other";
})(TimeBreakType || (TimeBreakType = {}));
export var TimeBreakStatus;
(function (TimeBreakStatus) {
    TimeBreakStatus["RUNNING"] = "running";
    TimeBreakStatus["FINISHED"] = "finished";
})(TimeBreakStatus || (TimeBreakStatus = {}));
//# sourceMappingURL=timeBreakModel.js.map